'use client'

import { createContext, useContext } from 'react'

import type { ReactNode } from 'react'
import type { TenantConfig } from '@/config/tenants/types'

interface TenantContextValue {
  tenant: TenantConfig
}

interface TenantContextProviderProps {
  children: ReactNode
  tenant: TenantConfig
}

const TenantContext = createContext<TenantContextValue | null>(null)

export function TenantContextProvider({ children, tenant }: TenantContextProviderProps) {
  return <TenantContext.Provider value={{ tenant }}>{children}</TenantContext.Provider>
}

export function useTenantContext(): TenantContextValue {
  const context = useContext(TenantContext)

  if (!context) {
    throw new Error('useTenantContext must be used within TenantContextProvider')
  }

  return context
}
